<template>
  <v-app id="app-home">
    <component :is="layout"></component>
  </v-app>
</template>

<script>
  import AppLayout from '@/components/layouts/AppLayout'
  import SimpleLayout from '@/components/layouts/SimpleLayout'

export default {
  name: 'App',
  components: {
    AppLayout, SimpleLayout 
  },
  computed: {
    layout(){
      return this.$store.getters.getLayout
    }
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style>
  #app-home {
    background: #151110 url("/img/main-background.jpg") center top;
  }
</style>
